/*
 * One-Minute Maths
 * Copyright © 2021 - 2024 White Rose Maths
 * MultiplicationArrayElement.js -
*/

import { StyleSheet, View } from 'react-native';

interface MultiplicationArrayElementProps {
  width: number,
  height: number,
  color: 'red' | 'yellow',
  margin: number
}

const MultiplicationArrayElement = ({width, height, color, margin}: MultiplicationArrayElementProps) => {

  const squareStyle = {width:width, height:height, marginLeft: margin};
  const circleStyle = {backgroundColor: color};

  return (
    <View style={[styles.square, squareStyle]}>
      <View style={[styles.circle, circleStyle]}/>
    </View>
  );
};

export default MultiplicationArrayElement;

const styles = StyleSheet.create({
  square: {
    color: '#20232a',
    textAlign: 'center',
    alignContent: 'center',
    alignItems: 'center',
    fontSize: 30,
    fontWeight: 'bold',
  },

  circle: {
    aspectRatio: 1,
    borderRadius: 200,
    borderWidth: 1,
    borderColor: '#000',
    borderStyle: 'solid',
    width: '95%',
    height: '95%',
  },

});
